import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

export const CinematicBreak = ({ image, alt, quote, caption }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="cinematic-break"
      className="relative h-[70vh] sm:h-[85vh] overflow-hidden bg-forest-deep grain"
    >
      <motion.div style={{ y: bgY }} className="absolute inset-0">
        <img
          src={image}
          alt={alt}
          loading="lazy"
          decoding="async"
          className="w-full h-[124%] object-cover"
        />
      </motion.div>
      <div aria-hidden="true" className="absolute inset-0 bg-forest-deep/55" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-forest-deep/80 via-transparent to-forest-deep/40" />
      {(quote || caption) && (
        <div className="relative z-[2] h-full wrap-x flex flex-col items-center justify-center text-center">
          {caption && (
            <Reveal>
              <p className="eyebrow text-gold-soft">{caption}</p>
            </Reveal>
          )}
          {quote && (
            <Reveal delay={0.12}>
              <p className="font-serif italic font-normal text-cream text-3xl sm:text-4xl lg:text-[44px] leading-[1.25] max-w-3xl mt-6">
                {quote}
              </p>
            </Reveal>
          )}
          <Reveal delay={0.22}>
            <div className="w-14 h-px bg-gold mt-8 mx-auto" />
          </Reveal>
        </div>
      )}
    </section>
  );
};
